import { useTypedParams } from '@sorare/routing';

import { RewardsEssenceLayout } from 'layouts/rewards/RewardsEssenceLayout';

import type { LayoutParams } from './__generated__/routeParams';

const RewardsEssenceLayoutComponent = () => {
  const { quality, rarity } = useTypedParams<LayoutParams>();
  return <RewardsEssenceLayout quality={quality} rarity={rarity} />;
};
export default RewardsEssenceLayoutComponent;
